import _ from 'lodash'
import { store } from '@/main'
import { ftsByDataType, sorterByDataType } from 'CORE/components/data-type/comparators'

/**
 * @var {ApiMiddleware}
 */
let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setResourcesApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        resources: [],
        resourceTypeFunctions: [],
    },
    getters: {
        resources: state => _.filter(state.resources, r => _.get(r, 'validUntil') === null),
        disabledResources: state => _.filter(state.resources, r => _.get(r, 'validUntil') !== null),
        resourceById: state => id => _.find(state.resources, ['id', id]),
        resourceTypeFunctions: state => state.resourceTypeFunctions,
        resourceTypeFunctionById: state => id => _.find(state.resourceTypeFunctions, { id: id }),
        resourceTypeFunctionByName: state => name => _.find(state.resourceTypeFunctions, { name: name }),
    },
    mutations: {
        setResources: (state, resources) => {
            state.resources = _
                .chain(resources)
                .map(p => {
                    p.propertyValues = _.mapValues(p.propertyValues, (v, k) => {
                        return {
                            value: v.value,
                            get $fts() {
                                const dataType = _.get(store.getters.propertyTypeByKey(k), 'type')
                                return ftsByDataType(v, dataType)
                            },
                            get $srt() {
                                const dataType = _.get(store.getters.propertyTypeByKey(k), 'type')
                                return sorterByDataType(v, dataType)
                            },
                        }
                    })
                    return p
                })
                .value()
            return state
        },
        addResource: (state, newResource) => {
            state.resources.push(newResource)
        },
        setResourceTypeFunctions: (state, resourceTypeFunctions) => {
            state.resourceTypeFunctions = resourceTypeFunctions
        },
    },
    actions: {
        async resourcesLoad({ commit }) {
            return api.get('/resource')
                .then(resources => {
                    commit('setResources', resources)
                })
        },
        async updateResource({ commit }, data) {
            return api.put(`/resource/${data.id}`, data)
                .then(r => {
                    return r
                })
        },
        async createResource({ commit }, data) {
            return api.post('/resource', data)
                .then(r => {
                    return r
                })
        },
        async disableResource({ rootGetters, dispatch }, id) {
            const resourceToDisable = rootGetters.resourceById(id)
            resourceToDisable.validUntil = Math.floor(Date.now() / 1000)
            await api.put(`/resource/${id}`, resourceToDisable)
        },
        async enableResource({ rootGetters, dispatch }, id) {
            const resourceToDisable = rootGetters.resourceById(id)
            resourceToDisable.validUntil = null
            await api.put(`/resource/${id}`, resourceToDisable)
        },
        async resourceTypeFunctionsLoad({ commit }) {
            return api.get('/resourceTypeFunction')
                .then(resourceTypeFunctions => {
                    commit('setResourceTypeFunctions', resourceTypeFunctions)
                })
        },
    },
})
